import React, { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import '../components/style/global.css';
import Home from './pages/Home';
import Header from './Header';
import Footer from './Footer';
import About from './pages/About';
import AnnouncementsProfile from './pages/announcementsProfile.js';
import Announcements from './pages/Announcements.js';
import InvestorForum from './pages/Community.js';
// import PitchDeck from './pages/PitchDeck.js';
import { Provider } from 'react-redux';
import store from './utils/store.js';
import Login from './pages/Login.js';
// import SignUp from './pages/signUp.js'
import PrivacyTOS from './pages/PrivacyTOS.js';
import ResetPassword from './pages/passwordReset.js';
import PrivateRoute from "./utils/PrivateRoute";
import InvestorProfile from './pages/investorProfile.js';
import Merch from './pages/Merch.js';
import { AuthProvider } from '../components/utils/AuthContext.js'; 
import ScrollToTop from './scrolltoTop.js';

// TESTAnnouncements
import TESTAnnouncementsProfile from './pages/TESTAnnouncementsProfile.js';
import TESTAnnouncements from './pages/TESTAnnouncements.js';

function WebsiteContainer() {
  const [currentPage, setCurrentPage] = useState('Home');
  const [showVideoPlayer, setShowVideoPlayer] = useState(false);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };


  return (
    <div className="app-container">
      <AuthProvider> 
      <Provider store={store}>
      {!showVideoPlayer && (
            <Header currentPage={currentPage} handlePageChange={setCurrentPage} />
          )}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home currentPage={currentPage} handlePageChange={setCurrentPage} />} />
        <Route path="/About" element={<About />} />
        <Route path="/announcements/:update"element={<PrivateRoute><AnnouncementsProfile setShowVideoPlayer={setShowVideoPlayer}  /></PrivateRoute>} />
        <Route path="/Announcements" element={<PrivateRoute><Announcements /></PrivateRoute>} />
        {/* <Route path="/PitchDeck" element={<PitchDeck />} /> */}
        <Route path="/BKFMerchShop" element={<Merch />} />

        <Route path="/TESTAnnouncements" element={<PrivateRoute><TESTAnnouncements /></PrivateRoute>} />
         <Route path="/TESTannouncements/:update"element={<PrivateRoute><TESTAnnouncementsProfile setShowVideoPlayer={setShowVideoPlayer}  /></PrivateRoute>} />

        <Route path="/InvestorForum" element={<PrivateRoute><InvestorForum /></PrivateRoute>} />
        <Route path="/Login" element={<Login />} />
        <Route path="/Privacy" element={<PrivacyTOS/>} />
        <Route path="/ResetPassword/:token" element={<ResetPassword/>} />
        <Route path="/InvestorProfile"  element={ <PrivateRoute> <InvestorProfile /> </PrivateRoute>
} /> 
      </Routes>
     
      {!showVideoPlayer && (
            <Footer currentPage={currentPage} handlePageChange={setCurrentPage} />
          )}
      </Provider>
      </AuthProvider>
    </div>
    
  );
}

export default WebsiteContainer;
